import { Action } from '@ngrx/store';
import { IQObservation } from '../../models/iq-observation.model';

export const GET_IQ_OBSERVATIONS = '[IQ Observations] Get Observations Request';
export const GET_IQ_OBSERVATIONS_FAIL = '[IQ Observations] Get Observations Fail';
export const GET_IQ_OBSERVATIONS_SUCCESS = '[IQ Observations] Get Observations Success';
export const CLEAR_IQ_OBSERVATIONS = '[IQ Observations] Clear Observations';

export class GetIQObservations implements Action {
  readonly type = GET_IQ_OBSERVATIONS;
  constructor(public payload: { showMockData: boolean }) {}
}

export class GetIQObservationsFail implements Action {
  readonly type = GET_IQ_OBSERVATIONS_FAIL;
  constructor(public payload: unknown) {}
}

export class GetIQObservationsSuccess implements Action {
  readonly type = GET_IQ_OBSERVATIONS_SUCCESS;
  constructor(public payload: IQObservation[]) {}
}

export class ClearIQObservations implements Action {
  readonly type = CLEAR_IQ_OBSERVATIONS;
}

// action types
export type IQObservationsAction =
  | GetIQObservations
  | GetIQObservationsFail
  | GetIQObservationsSuccess
  | ClearIQObservations;
